import { ajax } from '../index'

/**
 * 订单相关接口
 */
export default {
  // 获取checkout数据
  checkout(params?: any) {
    return ajax.get('api', `/api/v1/order/checkout`, params || {})
  },

  // 创建订单
  create(params: any) {
    return ajax.post('api', `/api/v1/order/create`, params)
  },

  // checkout页面确认是否有未支付的订单
  checkOrder(params: any) {
    return ajax.get('api', `/api/v1/order/check-order`, params)
  },

  // paymentresult
  result(id: string | number) {
    return ajax.get('api', `/api/v1/payment/result/${id}`, {})
  },

  // bpay
  bpayResut(id: string | number) {
    return ajax.get('api', `/api/v1/payment/b-pay/${id}`, {})
  },

  // 订单跟踪
  trackOrder(params: any) {
    return ajax.get('api', `/api/v1/order/track-order`, params)
  },
}